<div class="row">
  <div class="col-12">
    <div class="card p-3 mb-3">
      <div class="d-flex align-items-center justify-content-between">
        <h4 class="page-title">Cancel Spot Booking List</h4>
      </div>
      <div class="table-responsive">
        <table class="table table-striped border mt-4">
          <thead>
            <tr>
              <!-- <th scope="col">User Name</th>-->
              <th scope="col">User Email</th>
              <th scope="col">Start Date</th>
              <th scope="col">End Date</th>
              <th scope="col">Slots</th>
              <th scope="col">Price</th>
              <th scope="col">VAT Amount</th>
              <th scope="col">Reason</th>
              <th scope="col">Create Date</th>
              <th scope="col">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let booking of SlotBookingList">
              <td>{{ booking.user_id.email }}</td>
              <td>{{ booking.startDate }}</td>
              <td>{{ booking.endDate }}</td>
              <td>{{ booking.slots }}</td>
              <td style="color: red; font-weight: bold">
                {{ booking.currency }}
                {{
                  booking.totalAmountWithoutVat
                    ? booking.totalAmountWithoutVat
                    : "-"
                }}
              </td>
              <td>{{ booking.currency }} {{ booking.totalVatAmount }}</td>
              <td>
                {{ booking.refundReason ? booking.refundReason : "-" }}
              </td>
              <td>{{ booking.created_at | date : "short" }}</td>
              <td>
                <div class="d-flex flex-wrap gap-1">
                  <button
                    class="btn btn-sm btn-primary mr-1 mb-1"
                    (click)="openRefundModal(booking)"
                    ngbTooltip="Click to refund"
                  >
                    Refund
                  </button>
                </div>
              </td>
            </tr>

            <tr>
              <td colspan="9" *ngIf="SlotBookingList.length == 0">
                No data found
              </td>
            </tr>
          </tbody>
        </table>
        <div
          class="d-flex justify-content-center mt-5"
          *ngIf="SlotBookingList.length != 0"
        >
          <ngb-pagination
            [(page)]="page"
            [pageSize]="pageSize"
            [collectionSize]="totalcount"
            [maxSize]="7"
            [rotate]="true"
            [ellipses]="false"
            [boundaryLinks]="true"
            (pageChange)="loadPage($event)"
          ></ngb-pagination>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #refundModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Refund Package</h5>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <form #refundForm="ngForm">
      <p>Would you like to refund full amount?</p>

      <!-- Radio -->
      <div class="form-group row">
        <div class="col-sm-8">
          <div class="form-check form-check-inline">
            <input
              class="form-check-input"
              type="radio"
              [(ngModel)]="detail.is_refund_full_amount"
              name="is_refund_full_amount"
              [value]="true"
            />
            <label class="form-check-label">Yes</label>
          </div>
          <div class="form-check form-check-inline">
            <input
              class="form-check-input"
              type="radio"
              [(ngModel)]="detail.is_refund_full_amount"
              name="is_refund_full_amount"
              [value]="false"
            />
            <label class="form-check-label">No</label>
          </div>
        </div>
      </div>

      <div
        *ngIf="detail.is_refund_full_amount === false"
        class="form-group row"
      >
        <label for="amountTotal" class="col-sm-4 col-form-label">
          Refund Amount ({{ refundData.currency }})
        </label>
        <div class="col-sm-8">
          <input
            type="number"
            class="form-control"
            name="amountTotal"
            [(ngModel)]="detail.amountTotal"
            [max]="maxValue"
            required
          />
          <small
            class="form-text text-danger"
            *ngIf="refundForm.submitted && !detail.amountTotal"
          >
            Please enter valid fee (Max: {{ maxValue }} {{ currency }})
          </small>
        </div>
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          (click)="modal.dismiss()"
        >
          Cancel
        </button>
        <button
          type="submit"
          class="btn btn-danger"
          [disabled]="getIsDisabled() || isLoading"
          (click)="submitRefund(refundForm)"
        >
          {{ isLoading ? "Refunding..." : "Submit" }}
        </button>
      </div>
    </form>
  </div>
</ng-template>
